import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-classroom",
  "use": "d2-classroom-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"d2-classroom\">\n  <defs>\n    <style>\n      #d2-classroom .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"d2-classroom_矩形_566_拷贝\" data-name=\"矩形 566 拷贝\" class=\"cls-1\" d=\"M20.986,5H21V23H7V13h4v1H8v8H20V5.633L8,4.372V10H7V4.267H6.986L7,4.133V4H7.014l0.077-.729L21.014,4.734ZM3,6H4V21H3V6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol